import af from './dict.af.json';
import en from './master_dictionary.json';
import zu from './dict.zu.json';
//import af_payments from '../../node_modules/@platsoft/grape-ui-payment-approval/src/translations/dict.af.json';
//import zu_payments from '../../node_modules/@platsoft/grape-ui-payment-approval/src/translations/dict.zu.json';
//import en_payments from '../../node_modules/@platsoft/grape-ui-payment-approval/src/translations/master_dictionary.json';

export default {
	af: af,
	zu: zu,
	en: en
	//af_payments: af_payments,
	//zu_payments: zu_payments,
	//en_payments: en_payments
};
